(() => {
  const BADGE_SELECTOR = '#trustedsite-tm-image';
  const MOUNT_SELECTOR = '[data-zalvaro-trustedsite-mount]';
  const MOBILE_QUERY = window.matchMedia('(max-width: 749px)');
  let scheduled = false;

  const visibleMount = () => {
    const mounts = Array.from(document.querySelectorAll(MOUNT_SELECTOR));
    return mounts.find((mount) => mount.getClientRects().length > 0) || null;
  };

  const setImportantStyle = (element, property, value) => {
    if (
      element.style.getPropertyValue(property) !== value ||
      element.style.getPropertyPriority(property) !== 'important'
    ) {
      element.style.setProperty(property, value, 'important');
    }
  };

  const placeBadge = () => {
    scheduled = false;

    const badge = document.querySelector(BADGE_SELECTOR);
    const mount = visibleMount();
    if (!badge || !mount) return;

    if (badge.parentElement !== mount) mount.appendChild(badge);

    setImportantStyle(badge, 'position', 'relative');
    setImportantStyle(badge, 'top', 'auto');
    setImportantStyle(badge, 'right', 'auto');
    setImportantStyle(badge, 'bottom', 'auto');
    setImportantStyle(badge, 'left', 'auto');
    setImportantStyle(badge, 'margin', '0');
    setImportantStyle(badge, 'transform', 'none');
    setImportantStyle(badge, 'box-shadow', 'none');
  };

  const schedulePlacement = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(placeBadge);
  };

  const observer = new MutationObserver(schedulePlacement);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style']
  });

  if (typeof MOBILE_QUERY.addEventListener === 'function') {
    MOBILE_QUERY.addEventListener('change', schedulePlacement);
  } else {
    MOBILE_QUERY.addListener(schedulePlacement);
  }

  window.addEventListener('load', schedulePlacement, { once: true });
  schedulePlacement();
})();
